import React from "react";
import { Outlet } from "react-router-dom";
import { Box, Flex, Text } from "@chakra-ui/react";
import AppButton from "@/features/line-sheet-sets/app-button";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import useRouterHelper from "@/features/ui/hooks/use-router-helper";
import useRestrictedFeatures from "@/features/auth/use-restricted-features";
import { LockIcon } from "@/features/pathpick/components/PathPickMembershipExpiredPanel";

/**
 * 오더하기/오더 관리 페이지의 접근 가드.
 *
 * 오더가 막힌 계정(user.restricted_features 에 ORDER)은 GNB에서 메뉴를 감추지만,
 * 대시보드 카드 등 다른 곳의 링크나 URL 직접 입력으로도 들어올 수 있어 라우트에서 한 번 더 막는다.
 */
export default function OrderAccessGuard() {
  const { t } = useI18nHelper();
  const { navigate } = useRouterHelper();
  const { isOrderRestricted, isLoading } = useRestrictedFeatures();

  // 유저 정보가 오기 전에는 그리지 않는다 — 정상 계정에 안내가 깜빡이지 않게.
  if (isLoading) {
    return null;
  }

  if (!isOrderRestricted) {
    return <Outlet />;
  }

  // 주소는 그대로 두고 화면만 대체한다.
  return (
    <Box sx={{ padding: "16px", height: "100%", overflow: "auto" }}>
      <Flex
        flex={1}
        minHeight={"420px"}
        flexDirection={"column"}
        alignItems={"center"}
        justifyContent={"center"}
        gap={"16px"}
        padding={"32px"}
        border={"1px solid #E5E5E3"}
        borderRadius={"8px"}
        background={"#FFFFFF"}
      >
        <Flex
          boxSize={"48px"}
          alignItems={"center"}
          justifyContent={"center"}
          borderRadius={"full"}
          background={"#E8F2FF"}
        >
          <LockIcon />
        </Flex>
        <Flex flexDirection={"column"} gap={"8px"} alignItems={"center"}>
          <Text
            textStyle={"body-lg-bold"}
            fontSize={"22px"}
            color={"#1D1D1B"}
            textAlign={"center"}
          >
            {t("common:navigation.buyer.order_access_denied.title")}
          </Text>
          <Text
            textStyle={"body-md-regular"}
            color={"#6F6F6C"}
            textAlign={"center"}
            maxWidth={"520px"}
          >
            {t("common:navigation.buyer.order_access_denied.description")}
          </Text>
        </Flex>
        <AppButton variant={"white"} onClick={() => navigate("/")}>
          {t("common:navigation.buyer.order_access_denied.cta_home")}
        </AppButton>
      </Flex>
    </Box>
  );
}
